module.exports = __webpack_public_path__ + "static/img/7bg_1.1027b43.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/7bg_1.png
// module id = 745
// module chunks = 1